<template>
        <div class="templateknowledge">
         
             
                
                <div class="row mx-2 p-2">
                        <div class=" col-md-5 mx-auto d-block card m-1 p-2 card-glass">
                                <div class="card-body">
                                    <h6 class="card-title text-danger text-center">အရေးပေါ်လူနာတင်လူနာတင်ယာဉ်အကူအညီယူရန်</h6>
                                    
                                   <div class="text-center p-2">
                                    <router-link to="/emergency" class="card-link btn btn-danger"> နှိပ်ပါ </router-link>
                                   </div>
                                    
                                </div>
                        </div>      

                           <div class=" col-md-5 mx-auto d-block card m-1 p-3 card-glass">
                                <div class="card-body">
                                    <h6 class="card-title text-secondary text-center"> ဆရာဝန်နှင့်သူနာပြုများ၏ အိမ်အရောက်အကူအညီရယူရန် </h6>
                                   
                                    <div class="text-center p-2">
                                    <router-link to="/doctor" class="card-link btn btn-secondary"> နှိပ်ပါ </router-link>
                                   </div>
                                    
                                </div>
                        </div>      

                         <div class=" col-md-5 mx-auto d-block card m-1 p-3 card-glass">
                                <div class="card-body">
                                    <h6 class="card-title text-primary text-center">ဆရာဝန်များကို ဖုန်းခေါ်ဆိုအကူအညီရယူရန်</h6>
                                    
                                   <div class="text-center p-2">
                                    <router-link to="/doctorph" class="card-link btn btn-primary"> နှိပ်ပါ </router-link>
                                   </div>
                                    
                                </div>
                        </div>      

                           <div class=" col-md-5 mx-auto d-block card m-1 p-3 card-glass">
                                <div class="card-body">
                                    <h6 class="card-title text-center text-dark"> ဆေးဝါးအိမ်အရောက်ပို့အကူအညီ </h6>
                                   
                                    <div class="text-center p-2">
                                    <router-link to="/medical" class="card-link btn btn-dark"> နှိပ်ပါ </router-link>
                                   </div>
                                    
                                </div>
                        </div>      

                    </div> 
                
        </div>
          
</template>

<script>
export default {
    name: 'Knowledge',

   
}
</script>

<style>
       .templateknowledge {
         
          background:linear-gradient(to right top, #f7e9be, #e2e8e9);
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 50px;
          min-height: 100vh;
          
        }
</style>